/* eslint no-use-before-define: 0 */
class Restrictions {
  /*:: static fromJson: (Object) => Restrictions */
  constructor(restrictions
  /*: Object*/
  ) {
    Object.assign(this, restrictions);
  }

}

Restrictions.fromJson = (json
/*: Object*/
) =>
/*: Restrictions*/
new Restrictions(parseRestrictions(json));

function parseRestrictions(data
/*: Object*/
)
/*: { [string]: boolean }*/
{
  if (!data) return {};
  return data.reduce((dict, restriction) => {
    const isRestricted = restriction.value === false;
    dict[restriction.name] = isRestricted; // eslint-disable-line no-param-reassign

    if (isRestricted) dict.isRestricted = isRestricted; // eslint-disable-line no-param-reassign

    return dict;
  }, {});
}

module.exports = Restrictions;